const fullArray = (value: number) => Array.from({ length: value }, (v, k) => k + 1);
const fromZeroFullArray = (value: number) => Array.from({ length: value }, (v, k) => k);
const fullArrayDefault = (length: number, defaultPosition: any ) => Array(length).fill(defaultPosition);

export {
  fullArray,
  fromZeroFullArray,
  fullArrayDefault,
}



// WEBPACK FOOTER //
// ./src/tools/fullarray.ts